<template>
  <div class="md-layout md-gutter earn-content">
    <div class="md-layout-item item-content">
      <img
        src="/img/earn-login.svg"
        class="item-explain-img"
        alt="Register"
        width="55"
        height="55"
      />
      <div>
        <h5 class="method-title">Sign up</h5>
        <span class="item-method"
          >Register for your free account and post your first item
          <span class="item-focus">(1000 bonus points)</span></span
        >
      </div>
    </div>
    <div class="md-layout-item item-content">
      <img
        src="/img/earn-add.svg"
        class="item-explain-img"
        alt="Add item"
        width="55"
        height="55"
      />
      <div>
        <h5 class="method-title">Add items</h5>
        <span class="item-method"
          >Add more items to your inventory
          <span class="item-focus"
            >(10 bonus points each, up to 1500 points)</span
          ></span
        >
      </div>
    </div>
    <div class="md-layout-item item-content">
      <img
        src="/img/earn-buying.svg"
        class="item-explain-img"
        alt="Transacting"
        width="55"
        height="55"
      />
      <div>
        <h5 class="method-title">Transact with</h5>
        <span class="item-method"
          >Transact with other users when you sell or lend an item to another
          user
          <span class="item-focus"
            >(you can receive points for those transactions)</span
          ></span
        >
      </div>
    </div>
    <div class="md-layout-item item-content">
      <img
        src="/img/earn-money.svg"
        class="item-explain-img"
        alt="Shipping"
        width="55"
        height="55"
      />
      <div>
        <h5 class="method-title">Ship items</h5>
        <span class="item-method"
          >If you ship an item to another user, your transaction partner can pay
          the shipping cost in points if you choose
          <span class="item-focus"
            >(points included into the item value)</span
          ></span
        >
      </div>
    </div>
    <div class="md-layout-item item-content">
      <img
        src="/img/earn-game.svg"
        class="item-explain-img"
        alt="Invite"
        width="55"
        height="55"
      />
      <div>
        <h5 class="method-title">Invite friends</h5>
        <span class="item-method"
          >Invite friends to earn
          <span class="item-focus"> up to 2500 points</span></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExplanationHowEarnPoints",
};
</script>

<style lang="scss" scoped>
.earn-content {
  margin-top: 1.5rem;
  flex-direction: column;
}
.item-content {
  display: flex;
  padding: 1.87rem;
  margin: 0 2.24rem 0 2.24rem;
}
.item-explain-img {
  margin-right: 1.69rem;
}
.method-title {
  color: $black;
}
.item-method {
  color: rgba(0, 0, 0, 0.68);
}
.item-focus {
  color: $primary;
}
</style>
